const alphabNumericOrUnderscoreRegex = /^[a-zA-Z][a-zA-Z0-9_]+$/;
export const isAlphaNumericOrUnderscore = (str: string) =>
  alphabNumericOrUnderscoreRegex.test(str);

export const toLowerCaseKabobCaseAlphaNumeric = (str: string) =>
  str
    .trim() // Remove leading and trailing spaces
    .replace(/[^a-zA-Z0-9]/g, '-') // Replace non-alphanumeric characters with dashes
    .replace(/-+/g, '-') // Replace multiple consecutive dashes with a single dash
    .replace(/^-+|-+$/g, '') // Remove leading and trailing dashes
    .toLowerCase();
